export default "__VITE_ASSET__D1M4wuBE__"